<template>
  <ValidationProvider
    #default="validationContext"
    :ref="refName"
    :name="name"
    :vid="name"
    :rules="rules"
    tag="div">
    <b-form-group
      :label="label"
      :state="$getValidationState(validationContext)"
    >
      <flat-pickr
        v-model="innerValue"
        v-bind="$attrs"
        class="form-control bg-white"
        :config="{ enableTime: true, noCalendar: true, dateFormat: 'H:i', time_24hr: true }"
      />

      <b-form-invalid-feedback :state="$getValidationState(validationContext)">
        {{ validationContext.errors[0] }}
      </b-form-invalid-feedback>
    </b-form-group>
  </ValidationProvider>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'

export default {
  components: {
    flatPickr
  },
  props: {
    value: {
      type: [String, Date],
      default: null
    },
    name: {
      type: String,
      required: true
    },
    rules: {
      type: [String, Object],
      default: () => {}
    },
    label: {
      type: String,
      default: ''
    },
    innerClass: {
      type: String,
      default: ''
    }
  },
  computed: {
    innerValue: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    refName () {
      return `validation-provider-${this.name}`
    }
  }
}
</script>

<style>

</style>
